import { BodyText } from '@postscript/components';

import { useGetCurrentPlan } from 'components/billing/context/useBilling';
import { useAIPlanBillingStatus } from 'components/billing/modules/plans/hooks/useAIPlanBillingStatus';

import { formatCentsToDollars } from 'components/billing/common/utils';

export const PricingDisclosure = () => {
  const { defaultAIPlan } = useAIPlanBillingStatus();
  const { data: marketingPlan } = useGetCurrentPlan();

  if (!defaultAIPlan || !marketingPlan) {
    return null;
  }

  if (
    marketingPlan.package?.sku === 'PROFESSIONAL' ||
    marketingPlan.package?.sku === 'ENTERPRISE'
  ) {
    return (
      <BodyText size="small">
        {/* Use Dynamic Pricing here */}
        <strong>Pricing:</strong> Platform pricing is{' '}
        {formatCentsToDollars(defaultAIPlan.platformFee)}/month (plus additional
        cost per AI message). You&apos;ll select a plan before completing
        registration.
      </BodyText>
    );
  }

  return (
    <BodyText size="small">
      <strong>Pricing:</strong> Per message cost is{' '}
      {formatCentsToDollars(defaultAIPlan.shopperResponseFee)} for Shopper,{' '}
      {formatCentsToDollars(defaultAIPlan.shopperAutomationFee)} for Shopper
      Automations, {formatCentsToDollars(defaultAIPlan.itAutomationFee)} for
      Infinity Testing Automations, and{' '}
      {formatCentsToDollars(defaultAIPlan.itCampaignFee)} for Infinity Testing
      Campaigns. You&apos;ll select a plan before completing registration.
    </BodyText>
  );
};
